import React from "react";

export const IconOption9 = () => {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.523438 8.68999L15.3042 0.523926L19.5711 7.59596L4.79029 15.762L0.523438 8.68999ZM10.1238 4.94718C8.35647 4.94718 6.92371 6.31822 6.92371 8.00946C6.92371 9.70074 8.35647 11.0717 10.1238 11.0717C11.8912 11.0717 13.324 9.70074 13.324 8.00946C13.324 6.31822 11.8912 4.94718 10.1238 4.94718ZM11.596 9.94327L11.1095 10.2121L10.8422 9.76895L10.3307 9.95977L9.90327 10.0202L9.71558 9.38978L10.1609 9.33877L10.6435 9.15731C10.7891 9.07591 10.8945 8.98294 10.9596 8.87841C11.0246 8.77389 11.0306 8.6737 10.9776 8.57795C10.9234 8.48889 10.8293 8.43818 10.6955 8.4258L10.165 8.4729C9.85275 8.53522 9.57769 8.5415 9.33987 8.49186C9.10209 8.44217 8.91238 8.30421 8.77085 8.07797C8.64231 7.8626 8.60476 7.641 8.65812 7.41316C8.71152 7.18533 8.85933 6.97129 9.10156 6.77105L8.83162 6.32368L9.31449 6.05691L9.56453 6.47132L10.0123 6.29458L10.3684 6.23437L10.5472 6.84829L10.218 6.88998L9.71446 7.08532C9.55883 7.17532 9.46554 7.26506 9.43455 7.35467C9.40356 7.44424 9.4103 7.52332 9.45476 7.59191C9.49779 7.66747 9.58613 7.70963 9.71984 7.7184L10.3122 7.65939C10.6639 7.5957 10.9465 7.60008 11.1599 7.67254C11.3733 7.74505 11.5434 7.88959 11.6701 8.1062C11.8003 8.32209 11.8386 8.54932 11.7851 8.78786C11.7316 9.02644 11.572 9.25139 11.3062 9.4628L11.596 9.94327Z"
        fill="#F2F2F2"
      />
    </svg>
  );
};
